var _rect, _rect2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgSvgClose = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 16,
  height: 16,
  fill: "none"
}, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
  width: 12.177,
  height: 1.4,
  x: 3.2,
  y: 11.812,
  fill: "#5C5C5C",
  rx: 0.7,
  transform: "rotate(-45 3.2 11.812)"
})), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
  width: 12.18,
  height: 1.4,
  x: 4.189,
  y: 3.2,
  fill: "#5C5C5C",
  rx: 0.7,
  transform: "rotate(45 4.189 3.2)"
})));
export default SvgSvgClose;